export function operacaoPreRecebimentoInRequest(params = {}) {
  return {
    type: '@operacaoprerecebimento/PRERECEBIMENTO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoPreRecebimento(prre_codigo) {
  return {
    type: '@operacaoprerecebimento/FIND_PRERECEBIMENTO',
    payload: { prre_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoprerecebimento/FAILED_REQUEST',
  };
}

export function deleteOperacaoPreRecebimento(prre_codigo, params) {
  return {
    type: '@operacaoprerecebimento/DELETE_PRERECEBIMENTO',
    payload: { prre_codigo, params },
  };
}

export function updateOperacaoPreRecebimento(operacaoprerecebimento, params) {
  return {
    type: '@operacaoprerecebimento/UPDATE_PRERECEBIMENTO',
    payload: { operacaoprerecebimento, params },
  };
}

export function storeOperacaoPreRecebimento(operacaoprerecebimento, params) {
  return {
    type: '@operacaoprerecebimento/STORE_PRERECEBIMENTO',
    payload: { operacaoprerecebimento, params },
  };
}

export function successInRequest(
  operacaoprerecebimento,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoprerecebimento/SUCCESS_IN_REQUEST',
    payload: { operacaoprerecebimento, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoprerecebimento) {
  return {
    type: '@operacaoprerecebimento/SUCCESS_REQUEST',
    payload: { operacaoprerecebimento },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoprerecebimento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function changeModal(params) {
  return {
    type: '@operacaoprerecebimento/CLOSE_MODAL',
    payload: { ...params },
  }
}

export function recordFiltering(params) {
  return {
    type: '@operacaoprerecebimento/RECORD_FILTERING',
    payload: { params },
  };
}
